<!-- eslint-disable -->
<template lang="pug">
    .multiselect(
        v-on-clickaway="close",
        :class=`{
            'multiselect_is-opened': isOpened,
            'multiselect_disabled': disabled,
        }`,
    )
        .multiselect__content
            .multiselect__selected-option(
                v-if="!multiple",
                v-text="selectedOptionLabel",
                :class="{'multiselect__content_light-gray': isPlaceholderDisplayed}",
                :title="isPlaceholderDisplayed ? '' : selectedOptionLabel",
            )
        .multiselect__options(:class="{'multiselect__options_is-opened': isOpened}")
            ul.multiselect__options-list(v-if="isOpened")
                li.multiselect__option(
                    v-for="option in options",
                    @click.stop="selectOption(option)",
                    :class=`{
                        'multiselect__option_is-selected': isOptionSelected(option),
                    }`
                )
                    | {{ option[label] }}
                    slot(:name="`multiline-option-${option.name}`")
        svg-icon.multiselect__icon(
            v-show="!loading",
            name="angle",
            size="base",
            :class=`{
                'multiselect__icon_is-opened': isOpened,
                'multiselect__icon_disabled': disabled
            }`,
            @mousedown.native.prevent.stop="toggle",
        )
</template>

<script>
    /*eslint-disable*/
    import { mixin as clickaway } from 'vue-clickaway';

    export default {
        props: {
            loading: {
                type: Boolean,
                default: false,
            },
            options: {
                type: Array,
                default () {
                    return [];
                }
            },
            label: {
                type: String,
                default: 'label',
            },
            innerValuesName: {
                type: String,
                default: 'multilevelValues'
            },
            multiple: {
                type: Boolean,
                default: true,
            },
            allowEmpty: {
                type: Boolean,
                default: true,
            },
            placeholder: {
                type: String,
                default: 'Placeholder'
            },
            selectedMultilineOptions: {
                type: String,
                default: ''
            },
            value: {
                type: Object,
                default () {
                    return {};
                }
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        },
        mixins: [clickaway],
        watch: {
            value (val) {
                if (val && !this.multiple) {
                    this.selectedOptions.length = 0;
                    this.selectedOptions.push(val);
                }
            },
        },
        data () {
            return {
                isOpened: false,
                selectedOptions: [],
                isPlaceholderDisplayed: false,
            }
        },
        methods: {
            toggle () {
                this.isOpened = !this.isOpened;
            },
            close () {
                this.isOpened = false;
            },
            isOptionSelected (option) {
                return this.selectedOptions.includes(option);
            },
            selectOption (option) {
                if (this.isOptionSelected(option)) {
                    this.removeOptionFromSelected(option);
                    this.$emit('select', this.selectedOptions);
                    return;
                }
                if (!this.multiple) {
                    this.selectedOptions.length = 0;
                }
                this.selectedOptions.push(option);
                this.$emit('select', this.selectedOptions);
            },
            removeOptionFromSelected (option) {
                if (this.selectedOptions.length === 1 && !this.allowEmpty) {
                    return;
                }
                this.selectedOptions.splice(this.selectedOptions.indexOf(option), 1);
            },
        },
        computed: {
            selectedOptionLabel () {
                if (this.isOpened) {
                    if (!this.multiple && this.selectedOptions.length && this.selectedOptions[0].label.includes(this.value.label)) {
                        this.isPlaceholderDisplayed = false;
                        return `${this.selectedOptions[0][this.label]} ${this.selectedMultilineOptions}`;
                    }
                    if (!this.multiple && this.selectedOptions.length) {
                        this.isPlaceholderDisplayed = false;
                        return `${this.selectedOptions[0][this.label]}`;
                    }
                } else {
                    return this.value && `${this.value.label + ' ' + this.selectedMultilineOptions}`
                }
                this.isPlaceholderDisplayed = true;
                return this.placeholder;
            }
        }
    }
</script>

<style scoped lang="scss">
    $min-multiselect-height: 40px;

    .multiselect {
        width: 100%;
        min-height: $min-multiselect-height;

        background: $x-color-white;
        color: $x-color-black;

        border: 1px solid $hsl-color-gray-74;
        border-radius: $border-radius-6;

        font-weight: normal;
        font-size: $font-size-16;
        line-height: $font-size-19;

        display: flex;
        flex-wrap: wrap;

        box-sizing: border-box;

        outline: none;

        position: relative;

        &:hover {
            border-color: $hsl-color-blue-56;
        }

        &:focus {
            border-color: $hsl-color-blue-56;
        }

        &:active {
            border-color: $hsl-color-blue-56;
        }

        &::placeholder {
            font-weight: lighter;
        }
    }

    .multiselect_disabled {
        opacity: 0.6;
        pointer-events: none;
    }

    .multiselect_is-opened {
        border-radius: $border-radius-6 $border-radius-6 0 0;
    }

    .multiselect__options {
        width: 100%;
        display: none;
        background: $x-color-white;
        border: 1px solid $hsl-color-gray-74;
        border-radius: 0;
        &_is-opened {
            display: block;
            position: absolute;
            top: calc(100% + 1px);
            border-top: none;
            z-index: 1000;
        }
    }

    .multiselect__content {
        width: 100%;
        height: 100%;
        padding: 12px 15px;
    }

    .multiselect__content_light-gray {
        color: $hsl-color-gray-51;
    }

    .multiselect__icon {
        color: $hsl-color-blue-56;
        border-radius: $border-radius-6;
        cursor: pointer;
        width: 40px;
        height: calc(100% - 2 * 1px);
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform .2s ease;
        position: absolute;
        right: 1px;
        top: 1px;
        &:before {
            display: none;
        }
        &_is-opened {
            transform: rotate(180deg);
        }
        &_disabled {
            color: #a6a6a6;
        }
    }

    .multiselect__option {
        width: 100%;
        height: 100%;
        min-height: 0;
        box-sizing: border-box;

        padding: 12px 15px;

        font-family: 'Rubik', Helvetica, Arial, sans-serif;
        @include text($font-size-16);

        line-height: normal;
        list-style: none;
        display: block;
        position: relative;

        &:hover {
            background-color: $hsl-color-gray-98;
            &.multiselect__option_is-selected {
                background: $hsl-color-red-70_8;
                color: $x-color-white;
            }
            .multiline-content {
                display: block;
            }
        }
    }

    .multiselect__option_is-selected {
        background-color: $hsl-color-gray-94;
    }

    .multiline-content {
        display: none;
        max-width: 100px;
        background: $x-color-white;
        width: 100%;
        border: 1px solid $hsl-color-gray-74;
        border-bottom: none;
        box-sizing: border-box;
    }

    .multiselect__selected-option {
        border-radius: 0;
        width: calc(100% - 40px);
        padding: 0;
        margin: 0;
        min-height: 0;
        font-size: 16px;
        line-height: 18px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .multiline-content__option {
        color: $x-color-full-black;
        border-bottom: 1px solid $hsl-color-gray-74;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        .cs-checkbox {
            margin-bottom: 0;
        }
        &:hover {
            background-color: $hsl-color-gray-94;
        }
    }

    .multiselect__options-list, .multiselect__options-list ul, .multiselect__options-list li {
        line-height: normal;
        list-style: none;
        position: relative;
    }

    .multiselect__options-list ul {
        opacity: 1;
        position: absolute;
        top: 0;
        left: 100%;
        z-index: 1000;
    }

    .multiselect__options-list li {
        cursor: default;
        float: left;
        white-space: nowrap;
    }

    .multiselect__options-list ul li {
        float: none;
    }
</style>
